import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import {
  PROCESS_STATUS_ENUM,
  setPopUp
} from "app/Components/Block/CellularDataOnOff/CellularDataOnOffSlice";
import { getMarketCode } from 'app/utilities/domain/domainConstants';


const CallBackPopUp = (props) => {
  console.log(props)
  const marketCode = getMarketCode().toLowerCase();
  const { processStatus, action, selectedSubscriber } = props.cellularDataOnOffSlice;

  const { setPopUp } = props;
  const {popUpTimeOut} = props.contentData;

  const subscriberNumber = selectedSubscriber.substring(0, 3) + '-' + selectedSubscriber.substring(3);

  const handleWhatsApp = () => {
    console.log('whatsApp');
  };

  useEffect(() => {
    if (props.cellularDataOnOffSlice.processStatus === 'success' || props.cellularDataOnOffSlice.processStatus === 'error') {
      setTimeout(() => {
        setPopUp(null)
      }, popUpTimeOut.value * 1000);
    }
  }, [props.cellularDataOnOffSlice.processStatus]);

  const popUpContent = {
    processing: {
      text: 'אנחנו מעדכנים את סטטוס הגלישה',
      image: require(`./../Images/loading.gif`)
    },
    success: {
      block: {
        text: <>הגלישה חסומה למנוי מספר <span className='purple'>{subscriberNumber}</span></>,
        image: require(`./../Images/success-${marketCode}.gif`)
      },
      unblock: {
        text: <>הגלישה פתוחה למנוי מספר <span className='purple'>{subscriberNumber}</span></>,
        image: require(`./../Images/success-${marketCode}.gif`)
      }
    },
    error: {
      text: <span className={'error-text'}>
        לא הצלחנו לעדכן סטטוס גלישה למנוי
        <div className={'whatsApp-container'} onClick={handleWhatsApp}>
          <Image src={require(`./../Images/whatsApp.svg`)} alt={'whatsApp'} />
          <span className={'whatsApp-text'}>
            לנציג אנושי ב-WhatsApp
          </span>
        </div>
      </span>,
      image: require(`./../Images/fail-${marketCode}.gif`)  
    }
  };

  const content = processStatus === PROCESS_STATUS_ENUM.SUCCESS ? popUpContent[processStatus][action] : popUpContent[processStatus];

  return (
    <div className={'popUp-container'}>
      <Image className={'image'} alt={'process'} src={content.image} />
      <span className={'text'}>
        {content.text}
      </span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cellularDataOnOffSlice: state.cellularDataOnOffSlice,
  };
};

const mapDispatchToProps = {
  setPopUp
};

export default connect(mapStateToProps, mapDispatchToProps)(CallBackPopUp);
